import { SettingsSection } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { CompanyContact } from '@features/invoicingSettings/elements/CompanyContact'
import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useDebouncedCallback } from '../../../../../../../../../../hooks/useDebouncedCallback'

export const ContactSettings = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const handleDebouncedContactEmailInputChange = useDebouncedCallback(() =>
    trackInvoicingSettings('E-mail address typed'),
  )
  const handleDebouncedContactFirstNameInputChange = useDebouncedCallback(() =>
    trackInvoicingSettings('First name typed'),
  )
  const handleDebouncedContactLastNameInputChange = useDebouncedCallback(() =>
    trackInvoicingSettings('Last name typed'),
  )
  const handleDebouncedContactPhoneInputChange = useDebouncedCallback(() =>
    trackInvoicingSettings('Phone number typed'),
  )

  return (
    <SettingsSection.Content title={t('settings.organization.external_invoice.contact.title')}>
      <CompanyContact
        emailLabel={t('settings.organization.external_invoice.contact.email.label')}
        firstNameLabel={t('settings.organization.external_invoice.contact.first_name.label')}
        lastNameLabel={t('settings.organization.external_invoice.contact.last_name.label')}
        onEmailChange={handleDebouncedContactEmailInputChange}
        onFirstNameChange={handleDebouncedContactFirstNameInputChange}
        onLastNameChange={handleDebouncedContactLastNameInputChange}
        onPhoneChange={handleDebouncedContactPhoneInputChange}
        phoneLabel={t('phone_number')}
        withHeading={false}
      />
    </SettingsSection.Content>
  )
}
